module.exports = __webpack_public_path__ + "static/media/admin-icon.60ffc787.svg";